import { render, staticRenderFns } from "./Wishes.vue?vue&type=template&id=32b74f3e&"
import script from "./Wishes.vue?vue&type=script&lang=js&"
export * from "./Wishes.vue?vue&type=script&lang=js&"
import style0 from "./Wishes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
